import { jsx as _jsx } from "react/jsx-runtime";
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useAvailabilityDescription } from '../hooks/useAvailabilityDescription';
const AvailabilityDescriptionContainer = ({ unavailableProduct, }) => {
    const { getKeyForText } = useAvailabilityDescription(unavailableProduct);
    if (!getKeyForText()) {
        return null;
    }
    return (_jsx(Box, { paddingBlockStart: "2", children: _jsx(TextAlpha, { as: "h3", variant: "subheadingS", children: getKeyForText() }) }));
};
export default AvailabilityDescriptionContainer;
